import { FC } from 'react';
import { RenderFilters } from '../../../Components/Custom/RenderFilters';
import { RenderSorting } from '../../../Components/Custom/RenderSorting';
import {
  INPUT_TYPE_DATE_RANGE,
  INPUT_TYPE_SEARCH,
  INPUT_TYPE_SELECT
} from '../../../helpers/helpers';

interface FiltersProps {
  params: URLSearchParams;
  setParams: any;
}

export const Filters: FC<FiltersProps> = ({ params, setParams }) => {
  const statuses = [
    { label: 'Pending', value: '1' },
    { label: 'Paid', value: '2' }
  ];

  const sortOrderOptions = [
    { label: 'Ascending', value: 'ASC' },
    { label: 'Descending', value: 'DESC' }
  ];

  const sortByOptions = [
    { label: 'User ID', value: 'id' },
    { label: 'User Name', value: 'name' },
    { label: 'Sum of POAndUv', value: 'rankingSumOfPoAndUv' },
    { label: 'Ranking 20%', value: 'ranking20Percent' },
    { label: 'Ranking 40%40%20%', value: 'ranking404020' },
    { label: 'PO Active', value: 'rankingPoActive' },
    { label: 'Left Leg Total Volume', value: 'rankingLeftLegTotalVolume' },
    { label: 'Right Leg Total Volume', value: 'rankingRightLegTotalVolume' },
    { label: 'Ranking PV', value: 'rankingPV' }
  ];

  const sortingInputs = [
    { param: 'sortBy', type: INPUT_TYPE_SELECT, options: sortByOptions },
    { param: 'sortOrder', type: INPUT_TYPE_SELECT, options: sortOrderOptions }
  ];

  const filterInputs = [
    {
      param: 'userId',
      type: INPUT_TYPE_SEARCH,
      placeholder: 'Search User ID'
    },

    {
      param: 'name',
      type: INPUT_TYPE_SEARCH,
      placeholder: 'Name'
    }
  ];

  return (
    <>
      <RenderSorting
        sortingInputs={sortingInputs}
        searchParams={params}
        setSearchParams={setParams}
      />
      <RenderFilters
        filterInputs={filterInputs}
        searchParams={params}
        setSearchParams={setParams}
      />
    </>
  );
};
